import createClient from "openapi-fetch";
import type { paths } from "./schema";

/** Типизированный клиент /api. Тот же origin, cookie сессии уходит сама. */
export const api = createClient<paths>({ baseUrl: "/api" });

export type ApiError = { error: string; message: string };
